import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';
import {takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';
import {HhsgSharedUserProfile} from '../../../models';
import {
  HhsgSharedConfigService,
  HhsgSharedLoadingService,
  HhsgSharedUserService
} from '../../../services';
import {Constants} from '../../../utilities/constants.util';
import {HhsgSharedUserApplication} from "../../../models";
import {LegacySideNavItemModel} from "../../models/legacy-side-nav-item.model";

@Component({
  selector: 'huron-layout-material-legacy',
  templateUrl: 'layout.component.html',
  styleUrls: ['layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  @Input() showApplications: boolean;
  @Input() showNotificationIcon: boolean = true;
  @Input() sideNavItems: LegacySideNavItemModel[] = [];
  @ViewChild(MatAccordion) accordion: MatAccordion;

  sideNavOpened: boolean = true;
  currentYear: number = new Date().getFullYear();
  user: HhsgSharedUserProfile = <HhsgSharedUserProfile>{};
  applicationNavItems: LegacySideNavItemModel[] = [];

  logoRoute: string;
  portalHome: string;
  isLoading: boolean;

  private _unsubscribe$ = new Subject<void>();
  private _userServiceSubscription: Subscription;
  private loadingSubscription: Subscription;
  private phoneWidth: number = 600;

  constructor(
    public configService: HhsgSharedConfigService,
    protected _userService: HhsgSharedUserService,
    private _loadingService: HhsgSharedLoadingService
  ) {
    this.portalHome = configService.appSettings.portalHome;

    this.loadingSubscription = this._loadingService.isLoading$.subscribe({
      next: (value) => this.isLoading = value,
      error: (error) => console.log(error.toString()),
      complete: () => this.isLoading = false
    });
  }

  ngOnInit() {
    if (window.innerWidth < this.phoneWidth) {
      this.sideNavOpened = false;
    }
    this.setLogoRoute();
    this.setupApplicationMenu();
  }

  public ngOnDestroy(): void {
    this._userServiceSubscription.unsubscribe();

    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }

    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  private createApplicationNavMenu(menuHeader: LegacySideNavItemModel) {
    this.applicationNavItems = [];
    if (this.user?.userApplications) {
      this.user.userApplications.forEach(app => {
        if (this.shouldAddNavApp(app)) {
          let navItem = new LegacySideNavItemModel();
          navItem.name = app.name;
          navItem.applicationId = app.applicationId;
          navItem.childApplicationUserId = this.getChildApplicationUserId(app);
          this.applicationNavItems.push(navItem);
        }
      });
      menuHeader.items = this.applicationNavItems;
    }
  }

  private shouldAddNavApp(app:HhsgSharedUserApplication) {
    let shouldAddApp = app.isActive
    && app.abbreviation.toUpperCase() !== Constants.HuronAcceleratorsAbbreviation
    && !this.applicationNavItems.some(navItem => navItem.applicationId === app.applicationId);

    return shouldAddApp;
  }

  private getChildApplicationUserId(app: HhsgSharedUserApplication): number {
    let applicationModels = this.user?.userApplications?.filter(x => x.applicationId === app.applicationId);
    return applicationModels?.length > 0 ? applicationModels[0].applicationUserId : 0;
  }

  private setupApplicationMenu() {
    let applicationMenuHeader = new LegacySideNavItemModel();
    applicationMenuHeader.name = "Applications";
    applicationMenuHeader.icon = "apps";

    this._userServiceSubscription = this._userService
      .getUserProfile()
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((user: HhsgSharedUserProfile) => {
        this.user = user;
        this.createApplicationNavMenu(applicationMenuHeader);
      });

    if (this.showApplications) {
      this.sideNavItems.unshift(applicationMenuHeader);
    }
  }

  private setLogoRoute() {
    let applicationAbbreviation = this.configService.appSettings.applicationAbbreviation;
    if (applicationAbbreviation === Constants.HuronAcceleratorsAbbreviation) {
      this.logoRoute = '/';
    } else {
      this.logoRoute = this.portalHome;
    }
  }
}
